/**
 * The staff candidate list now lives in the React app (tf-frontend, /react/candidates).
 * Every link to the Vue list (`/candidate-list`, `/candidate-list/super_customer[/...]`) is sent
 * there with its filters, so saved links and the many in-app links keep working.
 *
 * Set to false to bring the Vue list back without touching the links.
 */
export const REACT_CANDIDATE_LIST = true;

const REACT_LIST_PATH = "/react/candidates";
const VUE_LIST_PATH = /^\/candidate-list(\/.*)?\/?$/;

/**
 * Where a navigation to the Vue candidate list should go instead, or null to let it through.
 * The query (filters in the `key=[a,b]` format both lists share) is kept as it is; the TFW
 * talent pool sub-route becomes `?pool=super_customer`, and the old full/short registration
 * sub-routes are dropped.
 */
export function reactCandidateListRedirect(to) {
  if (!REACT_CANDIDATE_LIST || !to || !to.path) return null;
  const match = VUE_LIST_PATH.exec(to.path);
  if (!match) return null;
  const query = { ...(to.query || {}) };
  if (/^\/super_customer(\/|$)/.test(match[1] || "")) query.pool = "super_customer";
  return { path: REACT_LIST_PATH, query };
}
